import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { WithDataAttributes } from '@/shared/model/WithDataAttributes';
import { FormFieldState } from '@/shared/ui/form/types';
import { Icon } from '@/shared/ui/icon';
import './field.scss';

type Props = ComponentPropsWithoutRef<'div'> & {
    id?: string;
    label?: ReactNode;
    labelOnTop?: boolean;
    right?: ReactNode;
    state?: FormFieldState;
    disabled?: boolean;
    children?: ReactNode;
    fieldsetProps?: WithDataAttributes<ComponentPropsWithoutRef<'fieldset'>>;
    legendProps?: WithDataAttributes<ComponentPropsWithoutRef<'legend'>>;
    labelProps?: WithDataAttributes<ComponentPropsWithoutRef<'label'>>;
};
export const Field = ({
    id,
    label,
    labelOnTop,
    right,
    state = 'default',
    disabled,
    children,
    className,
    fieldsetProps,
    legendProps,
    labelProps,
    ...props
}: Props) => {
    return (
        <div
            className={cn(
                'field',
                state === 'success' && 'field--valid',
                state === 'error' && 'field--invalid',
                disabled && 'field--disabled',
                labelOnTop && 'field--label-top',
                !label && 'field--no-label',
                className,
            )}
            {...props}
        >
            {children}
            <fieldset
                aria-hidden={true}
                {...fieldsetProps}
                className={cn('field__fieldset', fieldsetProps?.className)}
            >
                <legend {...legendProps} className={cn('field__legend', legendProps?.className)}>
                    <span className={cn('field__legend-content', !label && 'field__legend-content--empty')}>
                        {label}
                    </span>
                </legend>
            </fieldset>
            {label && (
                <label {...labelProps} className={cn('field__label', labelProps?.className)} htmlFor={id}>
                    {label}
                </label>
            )}
            {state === 'success' && (
                <Icon name="check" className={cn('field__status-icon', 'field__status-icon--success')} />
            )}
            {state === 'error' && (
                <Icon name="error" className={cn('field__status-icon', 'field__status-icon--invalid')} />
            )}
            {right && <div className="field__right-content">{right}</div>}
        </div>
    );
};
